
import { TranslationFunction } from 'smartstream-widgets/types/sharedModule/core'

export const competitionTranslations = (t: TranslationFunction) => ({
  'today': t('competitions.today.translation', {
    defaultValue: 'Today',
    context: 'Today games abbreviation'
  }),
  '19': t('competitions.championsLeague.translation', {
    defaultValue: 'Champions League',
    context: 'Champions League abbreviation'
  }),
  '36': t('competitions.epl.translation', {
    defaultValue: 'EPL',
    context: 'english premier league abbreviation'
  }),
  '40': t('competitions.bundesliga.translation', {
    defaultValue: 'Bundesliga',
    context: 'Bundesliga abbreviation'
  }),
  '53': t('competitions.laLiga.translation', {
    defaultValue: 'La Liga',
    context: 'La Liga abbreviation'
  }),
  '54': t('competitions.serieA.translation', {
    defaultValue: 'Serie A',
    context: 'Serie A abbreviation'
  }),
  '63': t('competitions.efl.translation', {
    defaultValue: 'EFL',
    context: 'efl abbreviation'
  }),
  '190': t('competitions.mls.translation', {
    defaultValue: 'MLS',
    context: 'mls abbreviation'
  }),
  '296': t('competitions.nfl.translation', {
    defaultValue: 'NFL',
    context: 'nfl abbreviation'
  }),
  '2667': t('competitions.nflProBowl.translation', {
    defaultValue: 'NFL Pro Bowl',
    context: 'NFL Pro Bowl abbreviation'
  }),
  '431': t('competitions.hcc.translation', {
    defaultValue: 'Heineken Champions Cup',
    context: 'Heineken Champions Cup abbreviation'
  }),
  '432': t('competitions.nba.translation', {
    defaultValue: 'NBA',
    context: 'nba abbreviation'
  }),
  '597': t('competitions.mlb.translation', {
    defaultValue: 'MLB',
    context: 'mlb abbreviation'
  }),
  '610': t('competitions.nhl.translation', {
    defaultValue: 'NHL',
    context: 'nhl abbreviation'
  }),
  '635': t('competitions.nascar.translation', {
    defaultValue: 'NASCAR',
    context: 'nascar abbreviation'
  }),
  '1033': t('competitions.ncaabk.translation', {
    defaultValue: 'NCAA BK',
    context: 'ncaa bk abbreviation'
  }),
  '1034': t('competitions.ncaafb.translation', {
    defaultValue: 'NCAA FB',
    context: 'ncaa fb abbreviation'
  }),
  '1035': t('competitions.cfl.translation', {
    defaultValue: 'CFL',
    context: 'cfl abbreviation'
  }),
  '2072': t('competitions.europaLeague.translation', {
    defaultValue: 'Europa League',
    context: 'Europa League abbreviation'
  }),
  '2155': t('competitions.nbaSummerLeague.translation', {
    defaultValue: 'NBA',
    context: 'nba summer league abbreviation'
  }),
  '2169': t('competitions.mlbAllStar.translation', {
    defaultValue: 'MLB',
    context: 'mlb all star abbreviation'
  }),
  '2254': t('competitions.nflPreseason.translation', {
    defaultValue: 'NFL Preseason',
    context: 'nfl preseason abbreviation'
  }),
  '12156': t('competitions.marchMadness.translation', {
    defaultValue: 'March Madness',
    context: 'March Madness abbreviation'
  }),
  '14066': t('competitions.superRugby.translation', {
    defaultValue: 'Super Rugby',
    context: 'Super Rugby abbreviation'
  }),
  '215': t('competitions.worldCup.translation', {
    defaultValue: 'World Cup',
    context: 'World Cup abbreviation'
  }),
  '15490': t('competitions.nflHallOfFame.translation', {
    defaultValue: 'NFL Hall Of Fame',
    context: 'NFL Hall Of Fame'
  })

} as { [competitionId in string]: string })

export const motorSportsIds = ['635']
